export default "__VITE_ASSET__B17ABDLC__"